import { useTheme } from "styled-components";
import { Text } from "../../../../../../../components/common";
import { CompanyLogo, Container, FullContainer, InputContainer, LabelContainer, TextAreaContainer } from "./label-input.styled";

interface LabelInputProps {
    label: string;
    image?: string;
    placeholder?: string;
    value?: string;
    onChange?: (value: string) => void;
    isDescription?: boolean;
}
const LabelInput: React.FC<LabelInputProps> = ({
    label,
    image,
    placeholder,
    value,
    onChange,
    isDescription
}) => {
    const theme = useTheme();
    return (
        <FullContainer>
            {!!image && <CompanyLogo src={image} alt={`${value}-image`}/>}
            <Container>
                <LabelContainer>
                    <Text color={theme.colors.primaryBlue.main} fontWeight={600} fontSize={15} margin="0 0 .5rem 0">
                        {label}
                    </Text>
                </LabelContainer>
                {!isDescription ? (
                    <InputContainer>
                        <input 
                            type="text" 
                            placeholder={placeholder}
                            value={value}
                            onChange={(e) => onChange && onChange(e.target.value)}
                            disabled={true}
                        />
                    </InputContainer>
                ) : (
                    <TextAreaContainer dangerouslySetInnerHTML={{__html: value || ''}} />
                )}
            </Container>
        </FullContainer>
    )
};

export default LabelInput;
